export const documents = new Map([
  ["National Identification Number (NIN)", "1"],
  ["Bank Verification Number (BVN)", "bvn"],
  ["Driver's License", "3"],
  ["International Passport", "4"],
  ["Voter's Card", "2"],
]);

export const documentList = Array.from(documents.keys());
